/* eslint-disable */

/** unique or primary key constraints on table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataConstraint {
  /** unique or primary key constraint on columns "material_udf_default_data_id" */
  MaterialUdfDefaultDataPkey = 'material_udf_default_data_pkey',
  /** unique or primary key constraint on columns "udf_column_id", "context_id", "material_model_id" */
  MaterialUdfDefaultDataUnique = 'material_udf_default_data_unique'
}

/** select columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_udf_default_data_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataSelectColumnArgoMaterialUdfDefaultDataAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_udf_default_data_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataSelectColumnArgoMaterialUdfDefaultDataAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.material_udf_default_data" */
export enum ArgoMaterialUdfDefaultDataUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

